<template>
    <Row>
        <!-- <Col span="8"  class="p2">
		<Select v-model="select.province" filterable @on-change="getCity">
        <Option v-for="item in province" :value="item.code" :key="item.code">{{ item.name }}</Option>
    </Select>
	</Col>
	<Col span="8"  class="p2">
		<Select v-model="select.city" filterable @on-change="getCountry">
        <Option v-for="item in city" :value="item.code" :key="item.code">{{ item.name }}</Option>
    </Select>
	</Col>
	<Col span="8" class="p2">
		<Select v-model="select.country" filterable @on-change="setValue">
        <Option v-for="i tem in country" :value="item.code" :key="item.code">{{ item.name }}</Option>
    </Select>    
	</Col> -->
        <Cascader filterable :data="hideDistrict?areaDistrict:isRenbao?renbaoData:areaList"  @on-change="change" :placeholder="placeholder" :value="handleCode(value)" style="width:100%">
        </Cascader>
        <input type="text" :value="value" v-show="false">
    </Row>
</template>
<script>
    import area from '@/assets/js/area.js'
    import areaDistrict from '@/assets/js/area.json'
    export default {
        data () {
            return {
                areaList: [],
                areaDistrict,
                renbaoData:[],
               
            }
        },
        props: ['value', 'areaCode', 'changeOnSelect', 'hideDistrict', 'placeholder','isRenbao'],
        created () {
            if (this.hideDistrict) {
                this.areaDistrict.forEach(item => {
                    item.children.forEach(one => {
                        delete one.children
                    })
                })
            } else {
                if(this.isRenbao) this.getArea()
                else  this.queryAreaTreeList()
            }
        },
        methods: {
            //获取省市区三级联动数据
            async queryAreaTreeList () {
                let res = await this.$axios.post("/common/queryAreaTreeList", { level: 3 })
                this.areaList = JSON.parse(JSON.stringify(res).replace(/name/g, "label").replace(/code/g, "value"))
            },
            handleCode (code) {
                if (code) {
                    let codeArray = []
                    if (code.substr(2, 4) == '0000') {
                        codeArray.push(code)
                    } else if (code.substr(4, 2) == '00') {
                        codeArray.push(code.substr(0, 2) + '0000')
                        codeArray.push(code.substr(0, 4) + '00')
                    } else {
                        codeArray.push(code.substr(0, 2) + '0000')
                        codeArray.push(code.substr(0, 4) + '00')
                        codeArray.push(code)
                    }
                    if(this.isRenbao&&codeArray[0]){
                        if(codeArray[0]==110000||codeArray[0]==120000||codeArray[0]==310000||codeArray[0]==500000){
                            codeArray[1]=codeArray[0]
                        }
                    } 
                    return codeArray
                }
            },
            change (code, val) {
                code = code[code.length - 1];
                this.$emit('input', code || '');
                this.$emit('get-city-str', val);
            },
                // 人保对接获取省市区
            getArea(){
                this.$axios.post('/common/queryZhbAreaTreeList.admin.json?level=3',{level:3}).then(res=>{
                    this.renbaoData=JSON.parse(JSON.stringify(res).replace(/name/g, "label").replace(/code/g, "value")) 
                })
            }
        },
        watch: {

        }
    }
</script>
<style>
    .p2 {
        padding: 0 2px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/Area.vue